import React from 'react';
import './PaymentPlan.css';

const PaymentPlan = ({ plans }) => {
  return (
    <div className="payment-plan">
      <h4 className="plan-title">Payment Plan</h4>
      
      <div className="plan-table">
        <div className="table-header">
          <div className="header-cell">Months</div>
          <div className="header-cell">Price</div>
          <div className="header-cell">Deposit</div>
          <div className="header-cell">
            <div className="installments-header">
              <span>Monthly</span>
              <span>Installments</span>
            </div>
          </div>
        </div>
        
        {plans.map((plan, index) => (
          <div key={index} className="table-row">
            <div className="table-cell">{plan.months}</div>
            <div className="table-cell">{plan.price}</div>
            <div className="table-cell">{plan.deposit}</div>
            <div className="table-cell">{plan.monthlyInstallments}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentPlan;
